// This file was generated automatically as a part of the SourceWhale ES6 refactor 🐳.
import { initializeGeneralUtils } from "../src/general/utils";
import { initializeSidebar } from "../../../svelte/src/bindings/sidebar.js";
import { bindSystemBannerNotifications } from "../../../svelte/src/bindings/system-banner-notifications.js";
import { bindTestPanel } from "../../../svelte/src/bindings/test-panel-prod.js";
import { bindTodosModal } from "../../../svelte/src/bindings/todos-modal.js";
import { initializeConfig } from "../src/general/config.js";
import { initializeReportUtils } from "../src/general/report-utils.js";
import { initializeTheme } from "../src/general/theme.js";
import { initializeTracking } from "../src/general/tracking.js";
import { initializeVisibilities } from "../src/general/visibilities.js";
import { initializeMarketingModal } from "../src/marketing/marketing.js";
import { initializeReports } from "../src/sidebar/reports.js";
import { initializeUploads } from "../src/uploads/uploads.js";
import { initializeWins } from "../src/wins/wins.js";

bindTestPanel();
bindSystemBannerNotifications();
bindTodosModal();
initializeTheme();
initializeConfig();
initializeGeneralUtils();
initializeVisibilities();
initializeReportUtils();
initializeReports();
initializeSidebar();
initializeTracking();
initializeWins();
initializeUploads();
initializeMarketingModal();
